import script from "./LabHome.vue?vue&type=script&setup=true&lang=js"
export * from "./LabHome.vue?vue&type=script&setup=true&lang=js"

import "./LabHome.vue?vue&type=style&index=0&id=c275febe&lang=css"
import "./LabHome.vue?vue&type=style&index=1&id=c275febe&lang=scss&scoped=true"
import "./LabHome.vue?vue&type=style&index=2&id=c275febe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c275febe"]])

export default __exports__